<div class="panel-custom">
  <div
    class="panel-custom__title"
    [ngClass]="{
      blue: color === 'blue',
      white: color === 'white',
      orange: color === 'orange',
      'direction-column': !!subtitle
    }"
  >
    <h1>{{ title }}</h1>
    <h2 *ngIf="subtitle">{{ subtitle }}</h2>
  </div>
  <div class="panel-custom__body">
    <ng-content></ng-content>
  </div>
</div>
